import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { environment } from '../../../environments/environment';
import { appVersion } from '../../../environments/version';
import { VersionService } from '../services/version.service';

export const versionInterceptor: HttpInterceptorFn = (req, next) => {
  const versionService = inject(VersionService);

  // Only attach the version header to requests that target the API origin
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const versionedReq = req.clone({
    setHeaders: { 'X-App-Version': appVersion }
  });

  return next(versionedReq).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 426) {
        const serverVersion =
          err.headers.get('X-Server-Version') ??
          (err.error as { serverVersion?: string } | null)?.serverVersion ??
          'unknown';
        versionService.setMismatch(serverVersion);
        return EMPTY;
      }
      throw err;
    })
  );
};

function isApiRequest(url: string): boolean {
  try {
    const requestOrigin = new URL(url).origin;
    const apiOrigin = new URL(environment.baseApiUrl).origin;
    return requestOrigin === apiOrigin;
  } catch {
    return false;
  }
}
